import { FC } from 'react'
import { isBefore, isSameDay, subDays } from 'date-fns'

import { durationInWords } from 'services/Dates'
import { DateTime } from 'components/UI'
import { Card } from 'ui'
import TimeOff from 'Employee/schedule/TimeOff/TimeOff'
import { Attendance } from 'Employee/schedule/Attendance'
import { Shift } from 'Employee/schedule/Shift'
import NoEvent from 'Employee/schedule/NoEvent'

import { t } from 'translations'

export type ShiftType = MData.Event & {
  hasAbsence?: boolean
  hasTimeOff?: boolean
  hasEarlyOut?: boolean
  hasLateArrival?: boolean
  linkedAttendances?: MData.Attendance[]
  canCreateAttendance?: boolean
  vacationTypeId?: string
  shiftTimeOffId?: string
  punchCard?: MData.PunchCard | 'notLoaded' | 'noShift' | 'errorLoading'
}

type EventType = ShiftType & MData.Attendance & MData.TimeOff

type Props = {
  isLoading: boolean
  days: { events: EventType[]; date: Date; approvedTime: number }[]
}

const WeekDesktop: FC<Props> = ({ isLoading, days }) => {
  return (
    <div className="d-flex flex-fill">
      {days.map(({ events, date, approvedTime }, index) => {
        const isToday = isSameDay(new Date(), date)
        const isBeforeToday = isBefore(date, subDays(new Date(), 1))
        const headerOpacity = isBeforeToday ? 0.6 : 1

        return (
          <Card key={index} className={`flex-grow-1 flex-even px-1 py-1 ${index && 'ml-1'} ${isToday ? 'border-primary' : ''}`}>
            <div
              className={`${isToday ? 'bg-primary' : 'bg-light'} mb-1 p-1 rounded d-flex flex-column align-items-center justify-content-end`}
              style={{ opacity: headerOpacity }}
            >
              <div className={`${isToday ? 'text-white' : 'font-weight-bold'} `}>
                <DateTime date={date} outFormat="humanDateCompact" />
              </div>
            </div>
            {/* Render the events */}
            {events.map(event => {
              if (event.isTimeOff) return <TimeOff key={event._id} timeOff={event} />
              if (event.isAttendance) return <Attendance key={event._id} attendance={event} />
              return <Shift key={event._id} shift={event} />
            })}
            {/* Render the total approved hours of the day if there is*/}
            {approvedTime ? (
              <div className="text-center">
                <span className="text-muted">
                  <i className="fas fa-clock"></i> {durationInWords(approvedTime, { short: true })} {t('employee.punch.APPROVED_TIME')}
                </span>
              </div>
            ) : null}
            {/* Render a no shift indicator */}
            {!events.length && <NoEvent key={index} date={date} isLoading={isLoading} />}
          </Card>
        )
      })}
    </div>
  )
}

export default WeekDesktop
